import React, { useState } from "react";
import PropTypes from "prop-types";
import I18n from "i18n-js";
import { Modal, Button, Radio, Space, Typography } from "@duxton-web/ui";
import { isMobile } from "react-device-detect";

import { getDefaultLanguage, setAvailableLanguage } from "../utils";
import { LANGUAGE_OPTIONS } from "../constants";
import "../assets/styles/language-selection.less";

const LanguageSelectionContent = ({ handleClickLanguage, onCancel }) => {
  const currentLanguage = getDefaultLanguage();
  const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);
  const availableLanguage = setAvailableLanguage();
  let languageList = [];

  availableLanguage.map((row) => {
    if (LANGUAGE_OPTIONS[row] !== undefined) {
      languageList.push({
        key: row,
        label: I18n.t(LANGUAGE_OPTIONS[row].text),
      });
    }
  });

  const handleOptionChange = (e) => {
    setSelectedLanguage(e.target.value);
  };
  const handleSaveLanguage = () => {
    handleClickLanguage({ key: selectedLanguage });
    onCancel();
  };
  const handleCancelLanguage = () => {
    setSelectedLanguage(currentLanguage);
    onCancel();
  };

  const getLanguage = (isCurrent, languageLabel) => {
    if (!isCurrent) {
      return languageLabel;
    }

    return I18n.t("troyCommon-navigation-004-002").replace(
      "<language>",
      languageLabel
    );
  };

  return (
    <div className="language-selection-modal">
      <Typography.Body style={{ fontSize: "20px" }}>
        {I18n.t("troyCommon-navigation-004-001")}
      </Typography.Body>
      <div>
        <Radio.Group
          onChange={handleOptionChange}
          value={selectedLanguage}
          defaultValue={selectedLanguage}
          style={{ marginTop: 24 }}
        >
          <Space direction="vertical" size={16}>
            {languageList.map((item) => {
              return (
                <Radio value={item.key}>
                  {getLanguage(currentLanguage === item.key, item.label)}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </div>

      <div style={{ marginTop: 24 }}>
        <Button
          block
          data-testid="saveLanguageButton"
          onClick={handleSaveLanguage}
          type="primary"
        >
          {I18n.t("troyCommon-navigation-004-003")}
        </Button>
        <Button
          block
          data-testid="cancelLanguageButton"
          type="secondary"
          onClick={handleCancelLanguage}
          style={{ marginTop: 16 }}
        >
          {I18n.t("troyCommon-navigation-004-004")}
        </Button>
      </div>
    </div>
  );
};

const TroyLanguageSelectionModal = (props) => {
  const {
    visible,
    onCancel,
    width,
    closable,
    maskClosable,
    handleClickLanguage,
  } = props;

  if (isMobile) {
    return (
      <div
        className="language-selection-fullscreen"
        style={{ display: visible ? "block" : "none" }}
      >
        {closable && (
          <div
            className="language-selection-fullscreen-close"
            onClick={onCancel}
          >
            &times;
          </div>
        )}
        <LanguageSelectionContent {...{ handleClickLanguage, onCancel }} />
      </div>
    );
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      width={width}
      withoutCloseIcon={closable}
      backdropClosable={maskClosable}
      footer={null}
      destroyOnClose
    >
      <LanguageSelectionContent {...{ handleClickLanguage, onCancel }} />
    </Modal>
  );
};

TroyLanguageSelectionModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  width: PropTypes.number,
  closable: PropTypes.bool,
  maskClosable: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  handleClickLanguage: PropTypes.func,
};

TroyLanguageSelectionModal.defaultProps = {
  visible: false,
  onCancel: () => null,
  width: 420,
  closable: true,
  maskClosable: true,
  isFullscreen: false,
  handleClickLanguage: () => null,
};

export { TroyLanguageSelectionModal };
